<template>
  <el-dialog
    :title="
      isEditDialog
        ? $t('dialog.titlePriceCodeEdit')
        : $t('dialog.titlePriceCodeAdd')
    "
    :visible="isShow"
    :close-on-click-modal="false"
    width="1200px"
    @close="onClose"
  >
    <div class="das-form-container">
      <validation-observer ref="formValidator">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-group">
                <div class="das-form-group-title">
                  {{ $t('views.configuration.priceCodeInformation') }}
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ $t('field.priceCode') }}
                      </div>
                      <validation-provider
                        rules="required|max:20"
                        :name="$t('field.priceCode')"
                      >
                        <input
                          v-model="formPriceCode.code"
                          type="text"
                          :readonly="isEditDialog"
                          @input="onInputCode"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <!-- <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ $t('field.priceCategory') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="$t('field.priceCategory')"
                      >
                        <select-with-search-table
                          index-field="id"
                          :dropdown-width="450"
                          :search-fields="['p_code', 'code', 'desc']"
                          :selected-index-field-value="
                            formPriceCode.price_category_id
                          "
                          :rows="priceCategoryOptions"
                          :columns="priceCategoryCols"
                          :value="formPriceCode.price_category_id"
                          :is-remove-btn="true"
                          @selectionChanged="onSelectPriceCategory"
                        >
                          <template
                            v-slot:value="{ selectedValue: selectedData }"
                          >
                            <span v-if="selectedData">{{
                              selectedData?.code
                            }}</span>
                          </template>
                        </select-with-search-table>
                      </validation-provider>
                    </div>
                  </div>
                </div> -->
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ $t('field.currency') }}
                      </div>
                      <validation-provider
                        rules="required|max:20"
                        :name="$t('field.currency')"
                      >
                        <select-with-search-table
                          index-field="id"
                          :dropdown-width="300"
                          :search-fields="['p_code', 'code', 'desc']"
                          :selected-index-field-value="
                            formPriceCode.currency_id
                          "
                          :rows="currencyOptions"
                          :columns="currCols"
                          :value="formPriceCode.currency_id"
                          @selectionChanged="onSelectCurrency"
                        >
                          <template
                            v-slot:value="{ selectedValue: selectedData }"
                          >
                            <span v-if="selectedData">{{
                              selectedData?.code
                            }}</span>
                          </template>
                        </select-with-search-table>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ $t('field.transactionRoomRate') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="$t('field.transactionRoomRate')"
                      >
                        <select-with-search-table
                          index-field="sub_transaction_id"
                          :dropdown-width="300"
                          :search-fields="[
                            'trans_id_nm_desc',
                            'sub_trans_id_nm_desc'
                          ]"
                          :selected-index-field-value="
                            formPriceCode.sub_room_transaction_id
                          "
                          :rows="roomTransOptions"
                          :columns="roomTransCols"
                          :value="formPriceCode.sub_room_transaction_id"
                          @selectionChanged="onSelectRoomTrans"
                        >
                          <template
                            v-slot:value="{ selectedValue: selectedData }"
                          >
                            <span v-if="selectedData"
                              >{{ selectedData.transaction_id }} -
                              {{ selectedData.sub_transaction_id }} -
                              {{ selectedData.sub_transaction_nm }}</span
                            >
                          </template>
                        </select-with-search-table>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <!-- <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">
                        {{ $t('field.orderDisplay') }}
                      </div>
                      <validation-provider :name="$t('field.orderDisplay')">
                        <input
                          v-model="formPriceCode.order"
                          v-numeric-only
                          type="number"
                          min="0"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div> -->
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <validation-provider
                      rules="max:255"
                      :name="$t('field.desc')"
                    >
                      <div class="das-form-input">
                        <div class="label">
                          {{ $t('field.desc') }}
                        </div>

                        <textarea
                          v-model="formPriceCode.desc"
                          rows="2"
                        ></textarea>
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <!-- <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="flex align-center gap-10" style="gap: 10px">
                      <div class="checkbox-wrap">
                        <input
                          id="isIncludeMeal"
                          v-model="isFormIncludeMeal"
                          type="checkbox"
                        />
                        <label for="isIncludeMeal">
                          {{ $t('field.includeMeal') }}
                        </label>
                      </div>
                      <div class="das-form-input">
                        <select
                          v-model="formPriceCode.meal_id"
                          :disabled="!isFormIncludeMeal"
                        ></select>
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">
                        <div class="checkbox-wrap">
                          <input
                            id="isFormIncludePack"
                            v-model="isFormIncludePack"
                            type="checkbox"
                          />
                          <label for="isFormIncludePack">
                            {{ $t('field.package') }}
                          </label>
                        </div>
                      </div>
                      <div class="flex align-center gap-10" style="gap: 10px">
                        <!-- <div class="checkbox-container">
                          <div class="checkbox-wrap">
                            <input
                              id="isFormIncludePack"
                              v-model="isFormIncludePack"
                              type="checkbox"
                            />
                            <label for="isFormIncludePack">
                              {{ $t('field.package') }}
                            </label>
                          </div>
                        </div> -->
                        <!-- <div class="das-form-input"> -->
                        <!-- <select
                          v-model="formPriceCode.meal_id"
                          :disabled="!isFormIncludeMeal"
                        ></select> -->
                        <div class="input-group">
                          <input
                            type="text"
                            :value="formPricePackageListText"
                            :disabled="!isFormIncludePack"
                            readonly
                          />
                          <div class="input-group__append input-group-btn">
                            <button
                              :disabled="!isFormIncludePack"
                              @click="fnOpenSelectPackDialog"
                            >
                              <i class="el-icon-more"></i>
                            </button>
                          </div>
                        </div>
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div
                    class="das-form-col col-12 checkbox-container"
                    style="gap: 10px"
                  >
                    <div class="checkbox-wrap">
                      <input
                        id="nett"
                        v-model="formPriceCode.nett"
                        type="checkbox"
                      />
                      <label for="nett">NETT</label>
                    </div>
                    <div class="checkbox-wrap">
                      <input
                        id="daily_price"
                        v-model="formPriceCode.daily_price"
                        type="checkbox"
                      />
                      <label for="daily_price">
                        {{ $t('field.priceDaily') }}
                      </label>
                    </div>
                    <div class="checkbox-wrap">
                      <input
                        id="stop_selling"
                        v-model="formPriceCode.stop_selling"
                        type="checkbox"
                      />
                      <label for="stop_selling">
                        {{ $t('field.stopSelling') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="das-form-group mt-20">
                <div class="das-form-group-title">
                  {{ $t('views.configuration.statistic') }}
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">
                        {{ $t('field.marketSegment') }}
                      </div>
                      <select-with-search-table
                        index-field="id"
                        :dropdown-width="560"
                        :search-fields="['p_code', 'code', 'desc']"
                        :selected-index-field-value="
                          formPriceCode.market_seg_id
                        "
                        :rows="marketSegOptions"
                        :columns="marketSegCols"
                        @selectionChanged="onSelectMarketSeg"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedSource }"
                        >
                          <span v-if="selectedSource"
                            >{{ selectedSource.code }} -
                            {{ selectedSource.p_code }}</span
                          >
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">
                        {{ $t('field.source') }}
                      </div>
                      <select-with-search-table
                        index-field="id"
                        :dropdown-width="600"
                        :search-fields="['p_code', 'code', 'desc']"
                        :selected-index-field-value="formPriceCode.source_id"
                        :rows="sourceOptions"
                        :columns="sourceCols"
                        @selectionChanged="onSelectSource"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedSource }"
                        >
                          <span v-if="selectedSource"
                            >{{ selectedSource.code }} -
                            {{ selectedSource.p_code }}</span
                          >
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-col col-8">
              <div class="das-form-group">
                <!-- <div class="das-form-group-title" style="height: 56px">
                  Giá theo hạng
                </div> -->
                <div class="price-by-level-section">
                  <div class="das-form-group-title">
                    {{ $t('views.configuration.priceRoomLevelByPeriod') }}
                  </div>
                  <!-- <div class="das-form-title-container">
                    <div class="das-form-title">
                      <div class="main-title">
                        {{ $t('views.configuration.pricePeriod') }}
                      </div>
                    </div>
                  </div> -->
                  <div class="das-form-row">
                    <div class="das-form-col col-6">
                      <div class="das-form-input">
                        <div class="label">
                          {{ $t('field.pricePeriod') }}
                        </div>
                        <div class="flex align-center">
                          <select-with-search-table
                            index-field="id"
                            style="width: 200px"
                            class="pr-5"
                            :dropdown-width="600"
                            :search-place-holder="
                              this.$t('infoMsg.searchByCode')
                            "
                            :search-fields="['code']"
                            :rows="priceByLevelOptions"
                            :columns="priceByLevelCols"
                            :selected-index-field-value="
                              priceByLevelSelected?.id
                            "
                            :disabled="formPriceCode.daily_price"
                            @selectionChanged="onSelectPriceByLevel"
                          >
                            <template
                              v-slot:value="{ selectedValue: selectedData }"
                            >
                              <span v-if="selectedData">{{
                                selectedData?.code
                              }}</span>
                            </template>
                          </select-with-search-table>
                          <button
                            class="btn only-icon edit"
                            :disabled="
                              !formPriceCode.code || formPriceCode.daily_price
                            "
                            @click="fnOpenPriceByLevelDialog"
                          ></button>
                        </div>
                      </div>
                    </div>
                    <div class="das-form-col col-6 align-self-end align-right">
                      <button
                        v-if="priceCodeId && isEditDialog"
                        class="btn primary small"
                        :disabled="!priceByLevelSelected"
                        @click="fnOpenEditPriceDialog"
                      >
                        {{ $t('button.changePriceOfRoomLevel') }}
                        <!-- {{ $t('button.cancel') }} -->
                      </button>
                    </div>
                  </div>
                  <div :v-loading="roomLevelGridLoading" style="height: 450px">
                    <GridVx
                      ref="roomLevelGrid"
                      :context="context"
                      dom-layout="scroll"
                      :columns="roomLevelCols"
                      :rows="roomLevelRows"
                      :auto-select-first-row="false"
                      row-selection="single"
                      class="agGrid"
                      @selectionChanged="onSelectRoomLevel"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small outline" @click="onClose">
          {{ $t('button.cancel') }}
        </button>
        <button
          v-if="isEditDialog"
          class="btn primary small"
          @click="fnUpdatePriceCode"
        >
          {{ $t('button.update') }}
        </button>
        <button v-else class="btn primary small" @click="fnAddPriceCode">
          {{ $t('button.create') }}
        </button>
      </div>
    </span>

    <!-- START DIALOGS -->
    <!-- Attach Package Dialog -->
    <PriceCodeSelectPackDialog
      :is-show="showPackDialog"
      :package-group-attached="formPriceCode.package_group"
      :package-attached="formPriceCode.package"
      :price-code-id="priceCodeId"
      @close="fnCloseSelectPackDialog"
      @selectPackages="onSelectPackages"
    />
    <PriceCodePriceByLevelDialog
      :is-show="showPriceByLevelDialog"
      :price-code-id="priceCodeId"
      :price-code-name="formPriceCode.code"
      :price-by-level-list="formPriceCode.price_by_level"
      :is-edit-dialog="isEditDialog"
      @updatePriceByLevelList="onUpdatePriceByLevel"
      @close="fnClosePriceByLevelDialog"
    />
    <PriceCodeEditPriceDialog
      :is-show="showEditPriceDialog"
      :price-by-level="priceByLevelSelected"
      :room-level="roomLevelSelected"
      @close="fnCloseEditPriceDialog"
      @updatePriceRoomLevel="fnUpdatePriceRoomLevel"
    />

    <!-- END DIALOGS -->
  </el-dialog>
</template>

<script>
import PriceCodeSelectPackDialog from './PriceCodeSelectPackDialog.vue'
import PriceCodePriceByLevelDialog from './PriceCodePriceByLevelDialog.vue'
import PriceCodeEditPriceDialog from './PriceCodeEditPriceDialog.vue'

import {
  getPaymentSubTransactionApi,
  getPriceByLevelList,
  getRoomPriceByLevelApi,
  getPriceCodeDetailApi,
  addPriceCodeApi,
  editPriceCodeApi,
  editPricePerRoomApi
} from '@/api/Service_Policy/priceCode'
import { getMarketSegmentApi } from '@/api/common/marketSegment'
import { getSourceListApi } from '@/api/common/source'
import { getPriceCategoryApi } from '@/api/common/priceCategory'
import { getAllCurrencyApi } from '@/api/common/currency'
import { CellRenderCurrencyInput } from '@/utils/cellRenders'

export default {
  components: {
    PriceCodeSelectPackDialog,
    PriceCodePriceByLevelDialog,
    PriceCodeEditPriceDialog,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCurrencyInput
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    isEditDialog: {
      type: Boolean,
      required: true
    },
    priceCodeId: Number
  },

  data() {
    return {
      isFormIncludeMeal: false,
      isFormIncludePack: false,
      formPriceCode: {
        id: null,
        code: null,
        price_category_id: null,
        currency_id: null,
        order: null,
        room_transaction_id: null,
        sub_room_transaction_id: null,
        nett: false,
        meal_id: null,
        desc: null,
        daily_price: true,
        stop_selling: false,
        market_seg_id: null,
        source_id: null,
        package_group: [
          // {
          //   package_id: null,
          //   package_nm: null,
          //   is_package_group: null
          // }
        ],
        package: [
          // {
          //   package_id: null,
          //   package_nm: null,
          //   is_package_group: null
          // }
        ]
      },
      formPricePackageListText: '',

      // SELECT OPTIONS
      marketSegOptions: [],
      sourceOptions: [],
      priceCategoryOptions: [],
      currencyOptions: [],
      roomTransOptions: [],
      mealOptions: [],
      priceByLevelOptions: [],
      priceByLevelSelected: null,
      roomLevelSelected: null,

      // Search with table Columns:
      marketSegCols: [
        {
          headerName: this.$t('grid.column.marketSegmentCode'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: 'grid-cell-centered',
          flex: 2,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc',
          // cellClass: 'grid-cell-centered',
          flex: 3,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.groupCode'),
          field: 'p_code',
          tooltipField: 'p_code',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
        }
      ],
      sourceCols: [
        {
          headerName: this.$t('grid.column.sourceCode'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc',
          // cellClass: 'grid-cell-centered',
          minWidth: 200,
          flex: 2,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.groupCode'),
          field: 'p_code',
          tooltipField: 'p_code',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
        }
      ],
      priceCategoryCols: [
        {
          headerName: this.$t('grid.column.categoryCode'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: 'grid-cell-centered',
          width: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc',
          // cellClass: 'grid-cell-centered',
          minWidth: 300,
          sortable: false
        }
      ],
      currCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'currency_unit',
          tooltipField: 'currency_unit',
          // cellClass: 'grid-cell-centered',
          flex: 3,
          sortable: false
        }
      ],
      roomTransCols: [
        {
          headerName: this.$t('grid.column.transaction'),
          field: 'trans_id_nm_desc',
          tooltipField: 'trans_id_nm_desc',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.subTransaction'),
          field: 'sub_trans_id_nm_desc',
          tooltipField: 'sub_trans_id_nm_desc',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
        }
      ],
      priceByLevelCols: [
        {
          headerName: this.$t('grid.column.periodCode'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
          // minWidth: 100,
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
          // minWidth: 100,
        },
        {
          headerName: this.$t('grid.column.fromDate'),
          field: 'date_from',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
          // minWidth: 100,
        },
        {
          headerName: this.$t('grid.column.toDate'),
          field: 'date_to',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
          // minWidth: 100,
        }
      ],
      roomLevelCols: [
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level_nm',
          tooltipField: 'room_level_nm',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          width: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'room_level_cd',
          tooltipField: 'room_level_cd',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.monday'),
          field: 'day_2',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          maxWidth: 150,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          sortable: false
        },
        {
          headerName: this.$t('grid.column.tuesday'),
          field: 'day_3',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          maxWidth: 150,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          sortable: false
        },
        {
          headerName: this.$t('grid.column.wednesday'),
          field: 'day_4',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          maxWidth: 150,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          sortable: false
        },
        {
          headerName: this.$t('grid.column.thursday'),
          field: 'day_5',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          maxWidth: 150,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          sortable: false
        },
        {
          headerName: this.$t('grid.column.friday'),
          field: 'day_6',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          maxWidth: 150,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          sortable: false
        },
        {
          headerName: this.$t('grid.column.saturday'),
          field: 'day_7',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          maxWidth: 150,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          sortable: false
        },
        {
          headerName: this.$t('grid.column.sunday'),
          field: 'day_8',
          // cellClass: 'grid-cell-centered',
          // flex: 1
          minWidth: 150,
          maxWidth: 150,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          sortable: false
        }
        // {
        //   headerName: this.$t('grid.column.singleGuest'),
        //   field: 'single_guest',
        //   // cellClass: 'grid-cell-centered',
        //   cellRenderer: 'CellRenderCurrencyInput',
        //   // flex: 1
        //   minWidth: 150,
        //   sortable: false
        // },
        // {
        //   headerName: this.$t('grid.column.doubleGuest'),
        //   field: 'double_guest',
        //   cellRenderer: 'CellRenderCurrencyInput',
        //   // flex: 1
        //   minWidth: 150,
        //   sortable: false
        // },
        // {
        //   headerName: this.$t('grid.column.forEachExtraGuest'),
        //   field: 'extra_guest',
        //   cellRenderer: 'CellRenderCurrencyInput',
        //   // flex: 1
        //   minWidth: 150,
        //   sortable: false
        // }
      ],
      roomLevelRows: [],
      roomLevelGridLoading: false,

      // DIALOG
      showPackDialog: false,
      showPriceByLevelDialog: false,
      showEditPriceDialog: false
    }
  },
  watch: {
    isShow: {
      handler(val) {
        if (val) {
          if (this.isEditDialog) {
            this.fnGetPriceCodeDetail()
            this.fnGetPriceByLevelOptions()
          }
        } else {
          this.fnResetDialogData()
        }
      },
      immediate: true
    },
    'formPriceCode.package_group': {
      deep: true,
      handler(val) {
        this.formPricePackageListText = [
          ...this.formPriceCode.package_group,
          ...this.formPriceCode.package
        ]
          .map(item => item.package_code)
          .join(', ')
      }
    },
    'formPriceCode.package': {
      deep: true,
      handler(val) {
        this.formPricePackageListText = [
          ...this.formPriceCode.package_group,
          ...this.formPriceCode.package
        ]
          .map(item => item.package_code)
          .join(', ')
      }
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.beforeHydrateState()
  },
  methods: {
    onInputCode(e) {
      const length = e.target.value.length
      this.formPriceCode.code =
        length > 20 ? this.formPriceCode.code.slice(0, 20) : e.target.value
    },
    // SELECT OPTIONS
    /** GET SELECT OPTIONS */
    async fnGetMarketSegOptions() {
      const data = await getMarketSegmentApi({ isActive: 1 })
      this.marketSegOptions = data.data
    },

    async fnGetSourceOptions() {
      const data = await getSourceListApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    async fnGetPriceCatOptions() {
      const data = await getPriceCategoryApi()
      this.priceCategoryOptions = data.data
    },
    async fnGetCurrencyOptions() {
      const data = await getAllCurrencyApi()
      this.currencyOptions = data.data
    },
    async fnGetRoomTransOptions() {
      const data = await getPaymentSubTransactionApi()
      this.roomTransOptions = data.data
      // this.roomTransOptions = data.data.filter(item => item.)
      this.roomTransOptions =
        this.roomTransOptions?.map(item => {
          return {
            ...item,
            ...{
              trans_id_nm_desc:
                item.transaction_id +
                ' - ' +
                item.transaction_nm +
                (item.transaction_desc ? ' - ' + item.transaction_desc : ''),
              sub_trans_id_nm_desc:
                item.sub_transaction_id +
                ' - ' +
                item.sub_transaction_nm +
                (item.sub_transaction_desc
                  ? ' - ' + item.sub_transaction_desc
                  : '')
            }
          }
        }) || []
    },
    async fnGetMealOptions() {},
    async fnGetPriceByLevelOptions() {
      const data = await getPriceByLevelList({ priceCodeId: this.priceCodeId })
      this.priceByLevelOptions = data.data
    },
    /** END GET SELECT OPTIONS */

    beforeHydrateState() {
      this.fnGetMarketSegOptions()
      this.fnGetSourceOptions()
      this.fnGetPriceCatOptions()
      this.fnGetCurrencyOptions()
      this.fnGetRoomTransOptions()
      this.fnGetMealOptions()
    },

    fnGetPriceCodeDetail() {
      getPriceCodeDetailApi({ id: this.priceCodeId })
        .then(res => {
          this.formPriceCode = {
            ...res.data,
            package_group: res.data.package_group?.map(item => ({
              ...item,
              is_package_group: true
            }))
          }
          this.isFormIncludePack =
            !!this.formPriceCode.package_group.length ||
            !!this.formPriceCode.package.length
          this.isFormIncludeMeal = !!this.formPriceCode.meal_id
        })
        .finally(() => {
          // bus.$emit('endLoader')
        })
    },
    async fnGetPriceByLevelDetailList() {
      if (this.isEditDialog && this.priceByLevelSelected.id) {
        // const selectedPriceByLevel = { ...data }
        this.roomLevelGridLoading = true
        getRoomPriceByLevelApi({ priceByLevelId: this.priceByLevelSelected.id })
          .then(res => {
            this.roomLevelRows = res.data
          })
          .catch(err => {
            this.$message({
              type: 'error',
              message: err.response.data.message || 'An error occurred'
            })
          })
          .finally(() => {
            this.roomLevelGridLoading = false
          })
      }
    },

    /** Update price of selecting row in Grid Table
     * @param {Map} priceData
     */
    fnUpdatePriceRoomLevel(priceData) {
      const roomLevelGridApi = this.$refs.roomLevelGrid.gridApi
      const selectedNode = roomLevelGridApi.getSelectedNodes()?.[0]
      if (selectedNode) {
        priceData.forEach((value, key) => {
          selectedNode.setDataValue(key, value)
        })
      }
    },

    // INPUTS
    onSelectPriceCategory(selected) {
      this.formPriceCode.price_category_id = selected?.id
    },
    onSelectMarketSeg(selected) {
      this.formPriceCode.market_seg_id = selected.id
    },

    onSelectSource(selected) {
      this.formPriceCode.source_id = selected.id
    },

    onSelectCurrency(selected) {
      this.formPriceCode.currency_id = selected.id
    },
    onSelectRoomTrans(selected) {
      this.formPriceCode.room_transaction_id = selected.transaction_id
      this.formPriceCode.sub_room_transaction_id = selected.sub_transaction_id
    },

    onSelectPackages(data) {
      this.formPriceCode.package_group = [...data.package_group]
      this.formPriceCode.package = [...data.package]
    },
    async onSelectPriceByLevel(data) {
      this.priceByLevelSelected = data ?? null
      if (this.isEditDialog) {
        // If price code is existed -> Get price by level detail of price code
        this.fnGetPriceByLevelDetailList()
      } else {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.mustSavePriceCodeBeforeEditingPriceByLevel'
          )
        })
      }
    },
    onSelectRoomLevel(rows) {
      this.roomLevelSelected = rows?.[0]
    },
    onUpdatePriceByLevel(data) {
      this.priceByLevelOptions = [...data]

      if (!this.isEditDialog) {
        this.formPriceCode.price_by_level = [...data]
      }
    },

    // GRID INPUTS
    changeCurrencyInput(params, value, field) {
      const idx = params.rowIndex
      const currentRoomLevelRow = this.roomLevelRows[idx]

      if (currentRoomLevelRow[field] !== value) {
        this.roomLevelRows[idx][field] = value

        // Update price per room
        const payload = {
          price_by_level_id: this.priceByLevelSelected.id,
          price_per_room: [
            {
              room_id: currentRoomLevelRow.room_level_id,
              single_guest: currentRoomLevelRow.single_guest,
              double_guest: currentRoomLevelRow.double_guest,
              extra_guest: currentRoomLevelRow.extra_guest
            }
          ]
        }

        this.fnEditPricePerRoom(payload)
      }
    },

    // FORM
    getDefaultPriceCodeForm() {
      return {
        id: null,
        code: null,
        price_category_id: null,
        currency_id: null,
        order: null,
        room_transaction_id: null,
        sub_room_transaction_id: null,
        nett: false,
        meal_id: null,
        desc: null,
        daily_price: true,
        stop_selling: false,
        market_seg_id: null,
        source_id: null,
        package_group: [],
        package: []
      }
    },

    fnResetDialogData() {
      this.formPriceCode = this.getDefaultPriceCodeForm()
      this.priceByLevelOptions = []
      this.roomLevelRows = []
      this.priceByLevelSelected = null
    },

    onClose() {
      if (this.isShow) {
        this.$vxConfirm(this.$t('alert.exitConfirm'), {
          resolveText: this.$t('button.exit'),
          rejectText: this.$t('button.stay'),
          resolve: () => {
            this.$emit('close')
          }
        })
      }
    },

    onClickCancel() {
      this.$vxConfirm(this.$t('alert.exitConfirm'), {
        resolveText: this.$t('button.exit'),
        rejectText: this.$t('button.stay'),
        resolve: () => {
          this.$emit('close')
        }
      })
    },

    // DIALOGS
    fnOpenSelectPackDialog() {
      this.showPackDialog = true
    },
    fnCloseSelectPackDialog() {
      this.showPackDialog = false
    },

    fnOpenPriceByLevelDialog() {
      this.showPriceByLevelDialog = true
    },

    fnClosePriceByLevelDialog() {
      this.showPriceByLevelDialog = false
    },

    fnOpenEditPriceDialog() {
      const roomLevelGridApi = this.$refs.roomLevelGrid.gridApi

      const selectedRows = roomLevelGridApi.getSelectedRows()

      if (!selectedRows?.length) {
        this.$message({
          type: 'error',
          message: 'Vui lòng chọn hạng phòng'
        })
      } else {
        this.roomLevelSelected = selectedRows[0]
        this.showEditPriceDialog = true
      }
    },
    fnCloseEditPriceDialog() {
      this.showEditPriceDialog = false
    },

    /**
     * @return {Object} priceCodePayload - body of Request
     */
    fnGetPriceCodePayloadForm() {
      return {
        ...this.formPriceCode,
        package_group: this.isFormIncludePack
          ? this.formPriceCode.package_group
          : null
      }
    },

    // ACTIONS
    async fnAddPriceCode() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      const payload = this.fnGetPriceCodePayloadForm()

      await addPriceCodeApi(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('refreshData')
          this.$emit('close')
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
        .finally(() => {})
    },
    async fnUpdatePriceCode() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      const payload = this.fnGetPriceCodePayloadForm()

      await editPriceCodeApi(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('refreshData')
          this.$emit('close')
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
        .finally(() => {})
    },
    async fnEditPricePerRoom(payload) {
      editPricePerRoomApi(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.fnGetPriceByLevelDetailList()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
        .finally(() => {})
    }
  }
}
</script>

<style></style>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
// .das-form-group-title {
//   color: #357456;
// }
.price-by-level-section {
  .das-form-title {
    height: 56px;
    display: flex;
    align-items: end;

    .main-title {
      padding: 0 !important;
      font-size: 18px;
    }
  }
}

.checkbox-wrap {
  white-space: nowrap;
}

.label {
  label {
    font-weight: 700 !important;
    color: #606266 !important;
    font-size: 14px !important;
  }
}

.align-self-end {
  align-self: self-end;
}

.align-right {
  text-align: right;
}

// .input-group {
//   display: flex;
//   height: 32px;
//   width: 100%;

//   input:first-child {
//     border-top-right-radius: 0;
//     border-bottom-right-radius: 0;
//   }

//   input:not(:first-child) {
//     border-top-left-radius: 0;
//     border-bottom-left-radius: 0;
//   }

//   .input-group__append,
//   .input-group__prepend {
//     padding: 6px 12px;
//     background-color: #cfd3d7;
//     height: 100%;
//     white-space: nowrap;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     color: $input-append-prepend-color;

//     &.input-group-btn {
//       cursor: pointer;
//       padding: 0;

//       button {
//         color: $input-append-prepend-color;
//         cursor: pointer;
//         background: transparent;
//         padding: 0 10px;
//         height: 100%;
//         width: 100%;
//         border: none;
//       }
//     }
//   }

//   .input-group__append {
//     // border-left: 1px solid #ddd;
//     border-top-right-radius: 5px;
//     border-bottom-right-radius: 5px;
//   }

//   .input-group__prepend {
//     // border-right: 1px solid #ddd;
//     border-top-left-radius: 5px;
//     border-bottom-left-radius: 5px;
//   }
// }
</style>
